import React from 'react'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ListItemText from '@material-ui/core/ListItemText';
import AttachmentIcon from '@material-ui/icons/AttachFile';

export default function list(props) {

let items ;
if(props.items){
    items = props.items.map((item)=>{return <ListItem key={item} >
    <IconButton aria-label="Downloaden" onClick={()=>window.open('https://aral.vedebo.net/documents/download?key='+item.split('/')[0])}>
        <AttachmentIcon />
      </IconButton>
    <ListItemText
      primary={item.split('/')[1]}
    />
    <ListItemSecondaryAction>
    {!props.readOnly 
      && <IconButton aria-label="Delete" onClick={()=>props.handleDelete(item)}>
      <DeleteIcon />
    </IconButton>}
     
    </ListItemSecondaryAction>
  </ListItem>
  })
}          
  return (
    <div>
        {items
        && <List dense={true}>{items}</List>
        }
          
    </div>
  )
}
